import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { AppSearchNavPhase1Props } from './AppSearchNavPhase1';

const AppSearchNavPhase1 = () => import(/* webpackChunkName: "4-feat-search-nav-phase1" */ './AppSearchNavPhase1');
const LoadableAppSearchNavPhase1: ComponentType<AppSearchNavPhase1Props> = lazyLoadOnRender({
  loader: AppSearchNavPhase1,
});
export default LoadableAppSearchNavPhase1;
